//===============================================================================
// © 2017 eWorkplace Apps.  All rights reserved.
// Original Author: Sanjeev Khanna
// Original Date: 07 July 2017
//==============================================================================

import { Pipe, PipeTransform } from '@angular/core'
import { CommonHelper } from '../helpers/common.helper';
import { ErrorHandlingService } from '../exception/error-handling.service';
import { PhoneNumberHelper } from '../helpers/phone-number.helper';

@Pipe(
    {
        name: "PhoneNumberPipe"
    }
)
/**
 * This pipe class provide to format and normazlie phohne number
 */
export class PhoneNumberPipe implements PipeTransform {

    constructor(private errorHandler:ErrorHandlingService) {

    }

    /**
     * 
     * @param value: Phone Number
     * @param normalizeNo: true, if normazlie number else format number 
     */
    public transform(value: string, normalizeNo: boolean): string {
        try {        
        if (CommonHelper.isEmpty(value))
            return  '';

        if (normalizeNo==true)
           return this.normalizeNumber(value)            
        else
         return this.formatedNumber(value);
        }
        catch(ex){
         this.errorHandler.handledError(ex, "PhoneNumberPipe.transform");
        }
    }
    private formatedNumber(phoneNumber: string): string {
        let countryCode: string = "91";
        let phoneNumberhelper: PhoneNumberHelper = new PhoneNumberHelper(countryCode, phoneNumber);
        //format Number
        let expectedFormattedNumber = phoneNumberhelper.format();
        return expectedFormattedNumber
    }

    private normalizeNumber(phohneNumber: string): string {
        let countryCode: string = "91";
        let actualNormalizedPhoneNumber: string = PhoneNumberHelper.normalize(phohneNumber, Number(countryCode));
        return actualNormalizedPhoneNumber
    }
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/pipe/phone-number.pipe.ts